let customOrder = require('../../actions/custom-order');
let filterableTree = require('../../actions/custom-order/filterable-tree');
let utils = require('../../actions/utils');
let error = require('../../actions/error');
let analytics = require('../../actions/analytics');
let { calcPriceGroup } = require('../groups/order/price');
let rubrics = require('../../actions/custom-order/rubrics');
let branches = require('../../actions/custom-order/branches');
let cities = require('../../actions/custom-order/cities');
let { defaultToBranches } = require('../groups/custom-order/index');

module.exports = {
    uploadTreeInputRubrics: [
        //utils.setArg('treeId', 'rubrics'),
        [
            customOrder.uploadTreeInput,
            {
                success: [
                    // очищаем список выбранных рубрик
                    utils.setArg('value', false),
                    rubrics.setAll,
                    // отмечаем распознанные рубрики, показываем нераспознанные
                    customOrder.showRubricsRecognitionResult,
                    customOrder.selectRubrics,
                    utils.setArg('showSelectedOnly', true),
                    filterableTree.setShowSelectedOnly,
                    ...calcPriceGroup
                ],
                error: [
                ]
            }
        ],
        utils.setArg('category', 'button_filter_rubrics_list'),
        utils.setArg('action', 'click'),
        analytics.raiseArgsValueEvent
    ],

    uploadTreeInputCities: [
        //utils.setArg('treeId', 'cities'),
        [
            customOrder.uploadTreeInput,
            {
                success: [
                    // очищаем список выбранных рубрик
                    utils.setArg('value', false),
                    cities.setAll,
                    // отмечаем распознанные рубрики, показываем нераспознанные
                    customOrder.showRubricsRecognitionResult,
                    customOrder.selectCities,
                    utils.setArg('showSelectedOnly', true),
                    filterableTree.setShowSelectedOnly,
                    ...calcPriceGroup
                ],
                error: [
                ]
            }
        ],
        utils.setArg('category', 'button_filter_cities_list'),
        utils.setArg('action', 'click'),
        analytics.raiseArgsValueEvent
    ],

    downloadRubricsFile: [
        [
            customOrder.downloadRubricsFile,
            {
                success: [],
                error: [
                    error.internalError('customOrder.downloadRubricsFile')
                ]
            }
        ],
        utils.setArg('category', 'button_download_rubrics'),
        utils.setArg('action', 'click'),
        analytics.raiseArgsValueEvent
    ],

    downloadCitiesFile: [
        [
            customOrder.downloadCitiesFile,
            {
                success: [],
                error: [
                    error.internalError('customOrder.downloadCitiesFile')
                ]
            }
        ],
        utils.setArg('category', 'button_download_cities'),
        utils.setArg('action', 'click'),
        analytics.raiseArgsValueEvent
    ],

    selectTab: [
        [
            customOrder.switchTabTransition,
            {
                branchesToDefault: [
                    utils.setArg('value', false),
                    cities.setAll,
                    utils.setArg('value', true),
                    branches.getCitiesTreeFilter,
                    cities.setSelection
                ],
                defaultToBranches: [
                    ...defaultToBranches
                ],
                default: []
            }
        ],
        utils.setFromArgsToState('tabId', ['order', 'cities', 'tab']),
        utils.unset(['order', 'cities', 'calcOnlyDefaultCities']),
        ...calcPriceGroup
    ]
};



// WEBPACK FOOTER //
// ./signals/custom-order/index.js